'use client';
import Api from '@/api';
import { ResponseType, Blog } from '@/commonTypes';
import InfiniteContent from '@/components/general/InfiniteContent';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React, { useEffect, useState } from 'react';

import { useTranslations } from 'next-intl';
import PageWrapper from '@/components/general/PageWrapper';

import blogStyle from './styles.module.css';

import { useSearchParams } from 'next/navigation';
import { useLayoutContext } from '@/context/LayoutContext';
import BlogsFiltersSection from './BlogsFiltersSection';
import { PageHero } from '@/components/general/PageHero';
import BlogsHero from './BlogsHero';
import BlogCard from '../../home/HomeContent/SampleBlogs/BlogCard';
import styles from './styles.module.css';
import BlogsAside from './BlogsAside';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { mapBlog } from '@/functions/mapApiData';

interface ContentType {
  data?: ResponseType<Blog>;
  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
}

export default function BlogsContent({
  data,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
}: ContentType) {
  const tCommon = useTranslations('common');
  const searchParams = useSearchParams();
  const { checkIfLogin } = useLayoutContext();
  const items = (data?.response || []).map(mapBlog);
  const totalCount = (data as any)?.count ?? 0;
  const populars = [...items].sort((a, b) => (b?.viewNum ?? 0) - (a?.viewNum ?? 0)).slice(0, 4);
  const [pageNumber, setPageNumber] = useState(page ? page : 1);
  const [list, setList] = useState({ response: items });
  const { width } = useWindowDimensions();

  useEffect(() => {
    setList({ response: (data?.response || []).map(mapBlog) });
  }, [data]);

  const popularBlogs = {
    response: populars,
  };
  const [tags, setTags] = useState<{ response: any[] }>({ response: [] });
  const [category, setCategory] = useState<{ response: any[] }>({ response: [] });

  useEffect(() => {
    Api.tagList({ params: { start: 0, limit: 20 } })
      .then((res: any) => setTags({ response: res?.data?.response || [] }))
      .catch((err) => console.error('tagList failed:', err));
    Api.blogCategoryList({ params: { start: 0, limit: 20 } })
      .then((res: any) => setCategory({ response: res?.data?.response || [] }))
      .catch((err) => console.error('blogCategoryList failed:', err));
  }, []);

  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);

  console.log('params====', params);
  const renderItem = () => (
    <BlogsAside popularBlogs={popularBlogs?.response} tags={tags?.response} tagSlug={tagSlug} />
  );
  return (
    <>
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <PageHero className={` ${styles.bottomPadding}`}>
            <BlogsHero setPageNumber={setPageNumber} />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-light pb-0`}>
        <ViewportWrapper className={`container py-0`}>
          <BlogCard
            item={items[0]}
            direction={'horizontal'}
            className={`${styles.featBlog}`}
            featured={true}
          />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-light p-0`}>
        <ViewportWrapper className={`container py-0`}>
          <BlogsFiltersSection
            category={category?.response}
            totalCount={totalCount}
            activeCategory={activeCategory}
            sortParams={{
              sort: searchParams?.get('sort'),
              orderBy: searchParams?.get('orderBy'),
            }}
            setPageNumber={setPageNumber}
            urlQuery={true}
            activeKey="slug"
          />
        </ViewportWrapper>

        <ViewportWrapper className={`container py-0`}>
          <div className={`${styles.layout}`}>
            {items && items?.length != 0 ? (
              <InfiniteContent
                page={page}
                params={params}
                initialList={{ response: items, response_details: { count: totalCount } }}
                list={list}
                setList={setList}
                limit={limit}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                apiCall={Api.blogList}
                gridClass={` ${blogStyle.posts_grid}`}
                renderItem={(item, index) => (
                  <BlogCard
                    item={item}
                    key={index}
                    index={index}
                    className={`${styles.blogCard}`}
                  />
                )}
                urlQuery={true}
                emptyText={'  هیچ بلاگی با فیلترهای شما مطابقت ندارد.'}
              ></InfiniteContent>
            ) : (
              <p className={`card notFound `}>بلاگ یافت نشد.</p>
            )}
            {renderItem()}
          </div>
        </ViewportWrapper>
        {/* <ViewportWrapper className={`container `}>
          <SubscribeBlog />
        </ViewportWrapper> */}
      </PageWrapper>
    </>
  );
}
